import { fromJS } from 'immutable';

import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, formatPattern } from '../../utils';

const onMetersAreLoading = isLoading => ({
    type: CONSTANTS.ON_METERS_ARE_LOADING,
    payload: { isLoading }
});

const onMetersList = data => ({
    type: CONSTANTS.ON_METERS_LIST,
    payload: { data }
});

const onMeterTypesAreLoading = isLoading => ({
    type: CONSTANTS.ON_METER_TYPES_ARE_LOADING,
    payload: { isLoading }
});

const onMeterTypesList = data => ({
    type: CONSTANTS.ON_METER_TYPES_LIST,
    payload: { data }
});

const onMeterFlavorsAreLoading = isLoading => ({
    type: CONSTANTS.ON_METER_FLAVORS_ARE_LOADING,
    payload: { isLoading }
})

const onMeterFlavorsList = data => ({
    type: CONSTANTS.ON_METER_FLAVORS_LIST,
    payload: { data }
})

const onMeterPurposesAreLoading = isLoading => ({
    type: CONSTANTS.ON_METER_PURPOSES_ARE_LOADING,
    payload: { isLoading }
});

export const onMeterPurposesList = data => ({
    type: CONSTANTS.ON_METER_PURPOSES_LIST,
    payload: { data }
});

export const fetchAllMeters = () => (dispatch, getState) => {
    const metersState = getState().meters.get('list');

    if (metersState.get('isLoading')) return;

    dispatch(onMetersAreLoading(true));

    return api(REQUEST_URL.METER, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onMetersList(fromJS(res.body)));
                dispatch(onMetersAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onMetersAreLoading(false));
            throw err;
        });
};

export const fetchMeterTypes = () => (dispatch, getState) => {
    const meterTypesState = getState().meters.get('types');

    if (meterTypesState.get('isLoading')) return;

    dispatch(onMeterTypesAreLoading(true));

    return api(REQUEST_URL.METER_TYPES, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onMeterTypesList(res.body));
                dispatch(onMeterTypesAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onMeterTypesAreLoading(false));
            throw err;
        });
};

export const fetchMeterPurposes = (meterId) => (dispatch, getState) => {
    const meterPurposesState = getState().meters.get('purposes');

    if (meterPurposesState.get('isLoading')) return;

    dispatch(onMeterPurposesAreLoading(true));

    return api(formatPattern(REQUEST_URL.METER_PURPOSES, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onMeterPurposesList(res.body));
                dispatch(onMeterPurposesAreLoading(false));
            }
        })
        .catch(err => {
            dispatch(onMeterPurposesAreLoading(false));
            throw err;
        });
};

export const fetchMeterFlavors = () => (dispatch, getState) => {
    const meterFlavorState = getState().meters.get('flavors');

    if(meterFlavorState.get('isLoading')) return;

    dispatch(onMeterFlavorsAreLoading(true));

    return api(REQUEST_URL.METER_FLAVORS, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onMeterFlavorsList(res.body));
                dispatch(onMeterFlavorsAreLoading(false))                ;
            }
        })
        .catch(err => {
            dispatch(onMeterFlavorsAreLoading(false));
            throw err;
        })
}

export const fetchWaPiProperties = (meterId, callback) => (dispatch, getState) => {

    dispatch(onMetersAreLoading(true));

    return api(formatPattern(REQUEST_URL.WA_PI_PROPS, {meterId}), METHOD.GET, undefined, {}, false, true)
        .then(res => {
            if (res && res.ok) {
                dispatch(onMetersAreLoading(false));
                if(callback) callback(res.text);
            }
        })
        .catch(err => {
            dispatch(onMetersAreLoading(false));
            throw err;
        });
};

export const fetchMqttAccessApi = (meterId, callback) => (dispatch, getState) => {

    dispatch(onMetersAreLoading(true));

    return api(formatPattern(REQUEST_URL.METER_MQTT_ACCESS_API, {meterId}), METHOD.GET, undefined, {}, false, true)
        .then(res => {
            if (res && res.ok) {
                dispatch(onMetersAreLoading(false));
                if(callback) callback(res.text);
            }
        })
        .catch(err => {
            dispatch(onMetersAreLoading(false));
            throw err;
        });
};

export const fetchHubStatus = (meterId, callback) =>
    api(formatPattern(REQUEST_URL.LATEST_MESSAGE, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body);
            }
        })
        .catch(err => {
            if(callback) callback();
            throw err;
        });

export const fetchHubMessages = (meterId, callback) =>
    api(formatPattern(REQUEST_URL.MESSAGES, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body);
            }
        })
        .catch(err => {
            if(callback) callback();
            throw err;
        });

export const fetchMeterSupportStatus = (meterId, callback) =>
    api(formatPattern(REQUEST_URL.METER_SUPPORT_GET, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body.tunnelActive);
            }
        })
        .catch(err => {
            if(callback) callback();
            throw err;
        });

export const changeMeterSupportStatus = (meterId, body) =>
    api(formatPattern(REQUEST_URL.METER_SUPPORT, { meterId }), METHOD.POST, body)
        .catch(err => {
            throw err;
        })

export const triggerMeterSupportUpdate = (meterId, body) =>
    api(formatPattern(REQUEST_URL.METER_SUPPORT, { meterId }), METHOD.POST, body)
        .catch(err => {
            throw err;
        })

export const deleteHubMessages = (meterId, callback) =>
    api(formatPattern(REQUEST_URL.MESSAGES, {meterId}), METHOD.DELETE)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body);
            }
        })
        .catch(err => {
            throw err;
        });

export const postHubMessage = (meterId, message, callback) =>
    api(formatPattern(REQUEST_URL.MESSAGES, {meterId}), METHOD.POST, message)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body);
            }
        })
        .catch(err => {
            throw err;
          });

export const fetchMeterConnectionStatus = (meterId, callback) =>
    api(formatPattern(REQUEST_URL.METER_STATUS, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                if(callback) callback(res.body);
            }
        })
        .catch(err => {
            if(callback) callback();
            throw err;
        });
